// extracted by mini-css-extract-plugin
export var closeButton = "_gn-1";
export var closeX = "_gn-3";
export var container = "_gn-0";
export var image = "_gn-2";